
export const environment = {
  production: false,
  currentApiHostname: 'wemas.dev.tgicarenet.com',
  pusher_secret: 'e5d1f0a002bdacaa0a22',
  pusher_cluster: 'mt1',
};
